import React from 'react';
import OccupantsSaveMode from 'components/structure/Occupant/OccupantsSaveMode';

export default function OccupantsDashboard() {
  // const {
  //   state: { user }
  // } = useAuth();

  return <OccupantsSaveMode />;
}
